import { ITranscription } from '../interfaces/ITranscriptionManager';
import 'isomorphic-fetch';
import { IStoredTranscription } from '../interfaces/IStoredTranscription';
import { SpeakerNameManager } from '../manager/speakerNameManager/SpeakerNameManager';
import { DocumentStorage } from '../office-js/DocumentStorage';
import { TranscriptionData } from '../utils/TranscriptionData';
import { StorageMigrationStatus } from './StorageMigrationHandler';
import { TranscriptionDocumentStorageManager } from './TranscriptionDocumentStorageManager';
import { isNullOrUndefined } from '../../utils/utils';

export class SingleTranscriptionDocumentStorageManager extends TranscriptionDocumentStorageManager {

  private transcriptionData: TranscriptionData | null = null;

    public constructor(documentStorage: DocumentStorage, storedTranscription?: IStoredTranscription) {
        if (isNullOrUndefined(documentStorage)) {
            throw new Error("Document Storage can't be null");
        }

        super(documentStorage);

        if (storedTranscription !== undefined) {
             this.documentStorageTypeFromStoredTranscription = storedTranscription.storageType;
            this.transcriptionData = new TranscriptionData(storedTranscription);
        }
    }

    public GetTranscription(): ITranscription {
        if (this.transcriptionData == null) {
            return {
                transcriptSegments: [],
            };
        }
        return this.transcriptionData.GetTranscription();
    }

    public async UpdateTranscriptionSegment(segmentIndex: number, segmentText: string, speakerName: string | null, updateAll: boolean) {
        if (this.transcriptionData != null) {
            let transcription: ITranscription = this.transcriptionData.GetTranscription();

            if (isNullOrUndefined(transcription.transcriptSegments))
                throw new Error("this.transcription.transcriptSegments is null");

            if (segmentIndex < 0 || segmentIndex >= transcription.transcriptSegments.length)
                throw new Error('Invalid segment index');

            transcription.transcriptSegments[segmentIndex].text = segmentText;

            let speakerNameManager: SpeakerNameManager = this.transcriptionData.GetSpeakerNameManager();
            if (speakerNameManager != null && speakerName != null)
                speakerNameManager.UpdateSpeakerName(segmentIndex, speakerName, updateAll);

            await this.WriteStoredTranscription(this.GetStoredTranscription());
        }
    }

    public GetStoredTranscription(): IStoredTranscription {
        if (this.transcriptionData == null) {
            return {
                storageType: this.documentStorage.SupportedDocumentStorageType!,
                descriptor: {},
            };
        }
        return this.transcriptionData.GetStoredTranscription();
    }

    public async WriteTranscriptionToStorage(storedTranscription: IStoredTranscription): Promise<void> {
        if (storedTranscription != null) {
            this.transcriptionData = new TranscriptionData(storedTranscription);
            await this.WriteStoredTranscription(storedTranscription);
        }
    }

    public async DeleteTranscription() {
        this.transcriptionData = null;
        await this.DeleteStoredTranscription();
    }

    public IsMultiTranscriptStorageSupported(): boolean {
        return false;
    }

    public GetStorageVersion(): number {
      return 0; // Please don't change it, 0 signifies IStoredTranscription.
    }

    public async HandleStorageMigration(): Promise<StorageMigrationStatus> {
      this.transcriptionData!.updateStorageType(this.documentStorage.SupportedDocumentStorageType!);
      return super.HandleStorageMigration();
    }
}